import { Button } from "@blueprintjs/core"
import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"

export const FormContainer = styled.form({
  width: "100%",
})

export const FormFooterContainer = styled(FlexContainer)({
  padding: "10px",
  width: "100%",
})

export const AddButton = styled(Button)({
  margin: "2px 0 12px",
})

export const addRowButtonCss = css({
  margin: "2px 0px 12px",
})
